const secondaryNavLinks = document.querySelectorAll('.secondary-nav__link, .scroll-to-section');

if (secondaryNavLinks.length) {
  const navListBody = document.querySelector('.secondary-nav__list');

  const sectionElements = {};
  secondaryNavLinks.forEach((link) => {
    const linkId = link.getAttribute('href');
    if (linkId && linkId !== '#') {
      let sectionElem;
      if (linkId.startsWith('#')) {
        sectionElem = document.getElementById(linkId.slice(1));
      } else if (linkId.startsWith('http')) {
        sectionElem = document.querySelector(`[href="${linkId}"]`);
      } else {
        sectionElem = document.querySelector(linkId);
      }
      sectionElements[linkId] = sectionElem;
    }
  });

  const scrollToSection = (sectionElem) => {
    const { top } = sectionElem.getBoundingClientRect();

    window.scrollTo({
      top: top + window.pageYOffset - getHeaderHeight(),
      behavior: 'smooth',
    });
  };

  const initScrollTriggers = () => {
    secondaryNavLinks.forEach((link) => {
      const linkId = link.getAttribute('href');
      const sectionElem = sectionElements[linkId];

      if (sectionElem) {
        gsap.timeline({
          scrollTrigger: {
            trigger: sectionElem,
            start: 'top center',
            end: 'bottom center',
            scrub: true,
            onToggle: (self) => {
              if (!self.isActive) {
                return;
              }

              if (windowWidth() <= breakpointMd) {
                const scrollPos = link.offsetLeft - (navListBody?.offsetWidth ?? 0) / 2 + (link?.offsetWidth ?? 0) / 2;
                navListBody?.scroll({
                  left: scrollPos,
                  behavior: 'smooth',
                });
              }
            },
            toggleClass: { targets: link, className: 'is-active' },
          },
        });
      }
    });
  };

  secondaryNavLinks.forEach((link) => {
    const linkId = link.getAttribute('href');
    const sectionElem = sectionElements[linkId];

    if (!sectionElem) {
      return;
    }

    link.addEventListener('click', (ev) => {
      scrollToSection(sectionElem);
      ev.preventDefault();
    });
  });

  window.addEventListener('load', () => {
    setTimeout(initScrollTriggers, 0);
  });
}
